import React from 'react';
import PropTypes from 'prop-types';
import { Circle } from 'better-react-spinkit';

import './style.scss';

const LoadingSpinner = ({ fullSize, style, circleProps }) => (
	<div className="spinner-outer" style={{ height: fullSize ? '70vh' : 'auto', ...style }}>
		<Circle
			scaleStart={0.4}
			scaleEnd={0.7}
			size={100}
			color="#000000"
			{...circleProps}
		/>
	</div>
);

LoadingSpinner.propTypes = {
  fullSize: PropTypes.bool,
	style: PropTypes.object,
	circleProps: PropTypes.object,
};

LoadingSpinner.defaultProps = {
  fullSize: false,
	style: {},
	circleProps: {},
};

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/ui/LoadingSpinner/index.js